(() => {
  if (window.PhotoBuyer) return;
  const element = document.getElementById('PhotoBuyerConfig');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const labels = config.labels;
  const key = 'the-other-perspective:favorites:v1';
  let persistent = true;
  let saved;
  const clean = value => new Set(Array.isArray(value) ? value.filter(item => typeof item === 'string' && /^[a-z0-9-]{1,200}$/.test(item)) : []);
  try { saved = clean(JSON.parse(localStorage.getItem(key) || '[]')); }
  catch { saved = new Set(); persistent = false; }
  const text = button => {
    if (!button.dataset.descriptionHtml) return button.dataset.description || '';
    const template = document.createElement('template');
    template.innerHTML = button.dataset.descriptionHtml;
    return template.content.textContent.trim();
  };
  const route = (type, gallery) => {
    const url = new URL(config.galleryUrl, config.origin);
    if (config.draft) url.searchParams.set('preview_theme_id', config.themeId);
    if (type === 'favorites') url.searchParams.set('view_favorites', '1');
    if (type === 'guide') url.searchParams.set('view_print_guide', '1');
    return url;
  };
  const detailUrl = (gallery, button) => {
    if (gallery.combinedPage) {
      const url = new URL(location.pathname + location.search,config.origin);
      if (config.draft) url.searchParams.set('preview_theme_id',config.themeId);
      url.searchParams.set('review_print',button.dataset.photo);
      url.searchParams.delete('review_combined');
      url.hash = '';
      return url.href;
    }
    const home = gallery.dataset.collageViewer === 'true';
    const url = new URL(home ? config.homeUrl : gallery.dataset.preview ? config.galleryUrl : location.pathname, config.origin);
    if (!home) url.search = location.search;
    for (const name of ['review_print','review_page','review_focus','view_print_guide','guide_photo','guide_size']) url.searchParams.delete(name);
    if (config.draft) url.searchParams.set('preview_theme_id', config.themeId);
    if (gallery.dataset.preview && !home) {
      if (gallery.dataset.scope !== 'all') url.searchParams.set('review_collection', gallery.dataset.scope);
      else url.searchParams.delete('review_collection');
    }
    if (home) url.searchParams.set('review_return', 'home');
    url.hash = 'photo=' + encodeURIComponent(button.dataset.photo);
    return url.href;
  };
  const inquiryUrl = (gallery, button) => {
    const url = new URL(config.contactUrl, config.origin);
    if (config.draft) url.searchParams.set('preview_theme_id', config.themeId);
    if (button) {
      url.searchParams.set('photo', button.dataset.title);
      url.searchParams.set('photograph', button.dataset.photo);
      url.searchParams.set('photo_url', detailUrl(gallery, button));
    }
    return url.href;
  };
  const updateSaved = (notify = false) => {
    for (const button of document.querySelectorAll('[data-favorite-handle]')) {
      const active = saved.has(button.dataset.favoriteHandle);
      button.setAttribute('aria-pressed', String(active));
      button.textContent = button.classList.contains('photo-buyer__card-save') ? (active ? labels.saved_short : labels.save_short) : (active ? labels.remove : labels.save);
      button.setAttribute('aria-label', (active ? labels.remove : labels.save) + ': ' + (button.dataset.favoriteTitle || ''));
    }
    for (const link of document.querySelectorAll('[data-photo-favorites]')) link.textContent = labels.saved + (saved.size ? ' (' + saved.size + ')' : '');
    if (notify) document.dispatchEvent(new CustomEvent('photo-buyer:saved'));
  };
  const toggle = handle => {
    if (!/^[a-z0-9-]{1,200}$/.test(handle)) return;
    if (saved.has(handle)) saved.delete(handle); else saved.add(handle);
    try { localStorage.setItem(key, JSON.stringify([...saved])); }
    catch { persistent = false; }
    updateSaved(true);
  };
  const actionRoot = gallery => gallery.combinedPage || gallery;
  const detailOpen = gallery => gallery.combinedPage ? !gallery.combinedPage.hidden : gallery.dialog.open;
  const status = (gallery, message) => { const node = actionRoot(gallery).querySelector('[data-photo-status]'); if (node) node.textContent = message; };
  const expired = gallery => gallery.reviewExpired?.();
  const updateDetail = gallery => {
    const button = gallery.currentPhoto;
    const actions = actionRoot(gallery).querySelector('[data-photo-actions]');
    if (!button || !actions) return;
    const save = actions.querySelector('[data-photo-save]');
    save.dataset.favoriteHandle = button.dataset.photo;
    save.dataset.favoriteTitle = button.dataset.title;
    save.setAttribute('aria-pressed', String(saved.has(button.dataset.photo)));
    save.textContent = saved.has(button.dataset.photo) ? labels.remove : labels.save;
    save.setAttribute('aria-label', save.textContent + ': ' + button.dataset.title);
    actions.querySelector('[data-photo-ask]').href = inquiryUrl(gallery, button);
    const guide = route('guide', gallery);
    guide.searchParams.set('guide_photo', button.dataset.photo);
    actions.querySelector('[data-photo-guide]').href = guide.href;
    actionRoot(gallery).querySelector('[data-photo-share-field]').hidden = true;
    status(gallery, '');
  };
  const share = async gallery => {
    if (expired(gallery)) { status(gallery, gallery.dataset.expiredLabel); return; }
    const photo = gallery.currentPhoto;
    const handle = photo.dataset.photo;
    const url = detailUrl(gallery, photo);
    if (navigator.share) {
      try { await navigator.share({title:photo.dataset.title, url}); return; }
      catch (error) { if (error.name === 'AbortError') { if (detailOpen(gallery) && gallery.currentPhoto.dataset.photo === handle) status(gallery, labels.share_cancelled); return; } }
    }
    try { await navigator.clipboard.writeText(url); if (gallery.currentPhoto.dataset.photo === handle) status(gallery, labels.share_copied + (config.draft ? ' ' + labels.draft_share : '')); }
    catch {
      if (!detailOpen(gallery) || gallery.currentPhoto.dataset.photo !== handle) return;
      const field = actionRoot(gallery).querySelector('[data-photo-share-field]');
      field.hidden = false;
      const input = field.querySelector('input');
      input.value = url;
      input.focus();
      input.select();
      status(gallery, labels.share_ready + (config.draft ? ' ' + labels.draft_share : ''));
    }
  };
  let colorRegistry;
  const imageIdentity = value => {
    try {
      const url = new URL(value, config.origin);
      if (!['http:','https:'].includes(url.protocol) || !['cdn.shopify.com',new URL(config.origin).hostname].includes(url.hostname)) return '';
      const version = url.searchParams.get('v');
      const file = url.pathname.match(/\/files\/([^/]+)$/);
      return version && file ? '/files/' + decodeURIComponent(file[1]) + '?v=' + version : '';
    } catch { return ''; }
  };
  const productIdentity = value => String(value || '').replace(/^gid:\/\/shopify\/Product\//, '');
  const loadColors = () => {
    if (colorRegistry) return colorRegistry;
    colorRegistry = (async () => {
      const result = new Map();
      if (!config.colorReviewUrl) return result;
      try {
        const response = await fetch(config.colorReviewUrl, {credentials:'same-origin'});
        if (!response.ok) return result;
        const data = await response.json();
        if (data.schemaVersion !== 1 || !Array.isArray(data.items)) return result;
        for (const item of data.items) {
          const image = imageIdentity(item.imageUrl);
          const product = productIdentity(item.productId);
          if (image && /^\d+$/.test(product) && ['color','monochrome'].includes(item.treatment)) result.set(product + '|' + image, item.treatment);
        }
      } catch {}
      return result;
    })();
    return colorRegistry;
  };
  const annotateColors = (records, registry) => {
    for (const button of records) {
      if (['color','monochrome'].includes(button.dataset.color)) continue;
      const treatment = registry.get(productIdentity(button.dataset.id) + '|' + imageIdentity(button.dataset.image));
      if (treatment) button.dataset.color = treatment;
    }
  };
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {maximumFractionDigits:2});
  const inches = values => values.map(value => formatter.format(value)).join(' × ') + ' in';
  const diagram = (container, size, photo) => {
    if (!size || ![...size.paper,...size.image,...size.border].every(Number.isFinite)) return;
    const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('viewBox', '0 0 ' + size.paper.join(' '));
    svg.setAttribute('role','img');
    svg.setAttribute('aria-label', labels.guide_diagram + ': ' + inches(size.paper) + '; ' + inches(size.image));
    svg.classList.add('photo-buyer__diagram');
    for (const attrs of [{x:0,y:0,width:size.paper[0],height:size.paper[1],fill:photo?.image?'#fff':'#f1eee8'},{x:size.border[0],y:size.border[1],width:size.image[0],height:size.image[1],fill:'#59695e'}]) {
      const rect = document.createElementNS(svg.namespaceURI,'rect');
      for (const [name,value] of Object.entries(attrs)) rect.setAttribute(name,String(value));
      svg.append(rect);
    }
    if (photo?.image) {
      const thumbnail = document.createElementNS(svg.namespaceURI, 'image');
      for (const [name, value] of Object.entries({x:size.border[0],y:size.border[1],width:size.image[0],height:size.image[1],href:(()=>{const url=new URL(photo.image,config.origin);url.searchParams.set('width',800);return url.href;})(),preserveAspectRatio:'xMidYMid meet'})) thumbnail.setAttribute(name,String(value));
      svg.lastElementChild.remove();
      svg.append(thumbnail);
      svg.setAttribute('aria-label', photo.title + ' — ' + labels.guide_diagram + ': ' + inches(size.paper) + '; ' + inches(size.image));
    }
    container.replaceChildren(svg);
  };
  const guidePage = gallery => {
    if (!new URLSearchParams(location.search).has('view_print_guide')) return false;
    const template = gallery.querySelector('[data-photo-print-guide]');
    if (!template) return false;
    for (const selector of ['.photo-gallery__heading','.photo-gallery__review','.photo-gallery__review-picker','photo-buyer-tools','.photo-gallery__grid','.photo-gallery__bio-link']) { const node=gallery.querySelector(selector); if(node)node.hidden=true; }
    const article = template.content.firstElementChild.cloneNode(true);
    article.querySelector('[data-guide-back]').href = route('',gallery).href + '#photographs';
    const photos = gallery.review?.photos || [];
    const picker = article.querySelector('[data-guide-photo]');
    const sizePicker = article.querySelector('[data-guide-size]');
    if (!photos.length) { article.querySelector('[data-guide-measurements]').hidden=true;article.querySelector('[data-guide-pending]').hidden=false;article.querySelector('[data-guide-ask]').href=inquiryUrl(gallery); }
    else {
      for (const photo of photos) picker.append(new Option(photo.title,photo.handle));
      const requested = new URLSearchParams(location.search).get('guide_photo');
      picker.value = photos.some(photo=>photo.handle===requested) ? requested : photos[0].handle;
      const update = () => {
        const photo = photos.find(item=>item.handle===picker.value);
        const size = (window.PhotoPrintOptions?.supplierSizes(photo) || photo.printSizes)[Number(sizePicker.value)];
        diagram(article.querySelector('[data-guide-diagram]'),size);
        article.querySelector('[data-guide-paper]').textContent=inches(size.paper);
        article.querySelector('[data-guide-image]').textContent=inches(size.image);
        article.querySelector('[data-guide-horizontal]').textContent=inches([size.border[0]]);
        article.querySelector('[data-guide-vertical]').textContent=inches([size.border[1]]);
        const button = gallery.querySelector('.photo-gallery__open[data-photo="'+photo.handle+'"]');
        article.querySelector('[data-guide-ask]').href=inquiryUrl(gallery,button);
      };
      const changePhoto = () => {const photo=photos.find(item=>item.handle===picker.value);const sizes=window.PhotoPrintOptions?.supplierSizes(photo)||photo.printSizes;sizePicker.replaceChildren(...sizes.map((size,i)=>new Option(inches(size.paper),String(i))));sizePicker.value=String(Math.min(1,sizes.length-1));update();};
      picker.addEventListener('change',changePhoto);sizePicker.addEventListener('change',update);changePhoto();
    }
    gallery.append(article);
    document.title=labels.guide_heading+' — '+labels.brand_name;
    return true;
  };
  const returnsPage = gallery => {
    if (!config.draft || new URLSearchParams(location.search).get('review_page') !== 'returns-cancellations') return false;
    const template = gallery.querySelector('[data-photo-returns]');
    if (!template) return false;
    for (const selector of ['.photo-gallery__heading','.photo-gallery__review','.photo-gallery__review-picker','photo-buyer-tools','.photo-gallery__grid','.photo-gallery__bio-link']) {
      const node = gallery.querySelector(selector);
      if (node) node.hidden = true;
    }
    const article = template.content.firstElementChild.cloneNode(true);
    article.querySelector('[data-returns-back]').href = route('',gallery).href + '#photographs';
    const title = article.querySelector('h1');
    title.id = 'PhotoReturnsTitle-' + gallery.id;
    article.setAttribute('aria-labelledby',title.id);
    gallery.append(article);
    document.title = title.textContent + ' — ' + labels.brand_name;
    return true;
  };
  const helpPage = gallery => {
    if (!config.draft || new URLSearchParams(location.search).get('review_page') !== 'help-with-your-print') return false;
    const template = gallery.querySelector('[data-photo-help]');
    if (!template) return false;
    for (const selector of ['.photo-gallery__heading','.photo-gallery__review','.photo-gallery__review-picker','photo-buyer-tools','.photo-gallery__grid','.photo-gallery__bio-link']) {
      const node = gallery.querySelector(selector);
      if (node) node.hidden = true;
    }
    const article = template.content.firstElementChild.cloneNode(true);
    article.querySelector('[data-help-back]').href = route('',gallery).href + '#photographs';
    const title = article.querySelector('h1');
    title.id = 'PhotoHelpTitle-' + gallery.id;
    article.setAttribute('aria-labelledby',title.id);
    gallery.append(article);
    document.title = title.textContent + ' — ' + labels.brand_name;
    return true;
  };
  const shippingPage = gallery => {
    if (!config.draft || new URLSearchParams(location.search).get('review_page') !== 'shipping-delivery') return false;
    const template = gallery.querySelector('[data-photo-shipping-delivery]');
    if (!template) return false;
    for (const selector of ['.photo-gallery__heading','.photo-gallery__review','.photo-gallery__review-picker','photo-buyer-tools','.photo-gallery__grid','.photo-gallery__bio-link']) {
      const node = gallery.querySelector(selector);
      if (node) node.hidden = true;
    }
    const article = template.content.firstElementChild.cloneNode(true);
    article.querySelector('[data-shipping-back]').href = route('',gallery).href + '#photographs';
    const title = article.querySelector('h1');
    title.id = 'PhotoShippingTitle-' + gallery.id;
    article.setAttribute('aria-labelledby',title.id);
    gallery.append(article);
    document.title = title.textContent + ' — ' + labels.brand_name;
    return true;
  };
  const decorate = card => {
    if (card.querySelector('[data-favorite-handle]')) return;
    const photo=card.querySelector('.photo-gallery__open');if(!photo)return;
    const caption=card.querySelector('figcaption');
    const save=document.createElement('button');save.type='button';save.className='photo-buyer__card-save';save.dataset.favoriteHandle=photo.dataset.photo;save.dataset.favoriteTitle=photo.dataset.title;caption.append(save);caption.classList.add('photo-buyer__card-caption');
  };
  class BuyerTools extends HTMLElement {
    connectedCallback() {
      if(this.initialized&&!this.abort?.signal.aborted)return;this.initialized=true;this.connectionVersion=(this.connectionVersion||0)+1;this.abort=new AbortController();this.gallery=this.closest('photo-gallery');const options={signal:this.abort.signal};
      this.gallery.addEventListener('photo-gallery:ready',()=>this.ready(),options);
      customElements.whenDefined('photo-gallery').then(()=>{if(this.gallery.buyerReady)this.ready();});
      this.addEventListener('input',event=>{clearTimeout(this.timer);if(event.target.matches('[data-photo-find]'))this.timer=setTimeout(()=>this.apply(true),350);else this.apply(true);},options);
      this.addEventListener('change',()=>{clearTimeout(this.timer);this.apply(true);},options);
      for(const name of ['click','keyup','focusout'])this.addEventListener(name,event=>{if(event.target.matches('[data-photo-orientation],[data-photo-color]')){clearTimeout(this.timer);this.timer=setTimeout(()=>this.apply(true),0);}},options);

      this.querySelector('[data-photo-reset]').addEventListener('click',()=>{clearTimeout(this.timer);this.querySelector('[data-photo-find]').value='';this.querySelector('[data-photo-orientation]').value='all';const color=this.querySelector('[data-photo-color]');if(color)color.value='all';this.apply(true);},options);
      this.gallery.addEventListener('change',event=>{if(event.target.matches('.photo-gallery__review-picker select'))this.apply(false);},options);
      document.addEventListener('photo-buyer:saved',()=>{if(this.favoriteMode&&!this.gallery.dialog.open)this.apply(false);},options);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.initialized=false;this.loaded=false;this.filtersReady=false;this.filterVersion=(this.filterVersion||0)+1;}
    async ready(){
      if(this.loaded)return;this.loaded=true;const connectionVersion=this.connectionVersion;this.filtersReady=false;if(returnsPage(this.gallery)||helpPage(this.gallery)||shippingPage(this.gallery)||guidePage(this.gallery)){this.filtersReady=true;return;}
      const query=new URLSearchParams(location.search);this.favoriteMode=query.get('view_favorites')==='1';
      this.querySelector('[data-photo-find]').value=query.get('find')||'';this.querySelector('[data-photo-orientation]').value=['landscape','portrait','square'].includes(query.get('orientation'))?query.get('orientation'):'all';
      this.querySelector('[data-photo-favorites]').href=route('favorites',this.gallery).href;
      this.querySelector('[data-photo-device-note]').hidden=!this.favoriteMode;
      this.gallery.dialog.addEventListener('close',()=>{if(this.favoriteMode && !saved.has(this.gallery.opener?.dataset.photo)){this.apply(false);this.querySelector('[data-photo-favorites]').focus();}},{signal:this.abort.signal});
      const grid=this.gallery.querySelector('.photo-gallery__grid');if(this.grid!==grid){this.grid=grid;this.originalNodes=[...grid.children];this.records=this.gallery.dataset.preview?[...grid.querySelectorAll('.photo-gallery__open')]:this.gallery.visibleItems(grid);this.totalCount=Number(this.gallery.nativePagination()?.dataset.galleryTotalCount)||this.records.length;}this.apply(false);
      this.colors = await loadColors();
      if (!this.isConnected || connectionVersion!==this.connectionVersion) return;
      annotateColors(this.records,this.colors);
      if (!this.querySelector('[data-photo-color]') && this.records.some(button=>['color','monochrome'].includes(button.dataset.color))) {
        const label=document.createElement('label');label.append(document.createTextNode(labels.color));
        const select=document.createElement('select');select.dataset.photoColor='';
        select.append(new Option(labels.all_colors,'all'),new Option(labels.color_label,'color'),new Option(labels.monochrome,'monochrome'));
        select.value=['color','monochrome'].includes(query.get('color'))?query.get('color'):'all';
        label.append(select);this.querySelector('.photo-buyer__filters').insertBefore(label,this.querySelector('[data-photo-reset]'));
      }
      const treatment=this.querySelector('[data-photo-color]');if(treatment)treatment.value=['color','monochrome'].includes(query.get('color'))?query.get('color'):'all';
      await this.apply(false);
      if(!this.isConnected || connectionVersion!==this.connectionVersion)return;
      this.filtersReady=true;
      this.gallery.dispatchEvent(new CustomEvent('photo-buyer:filters-ready'));
      this.querySelector('.photo-buyer__find').open=this.hasActiveFilters();
      this.gallery.openFromHash();
      this.gallery.restoreReturnFocus?.();
    }
    async restoreFromUrl(){
      if(!this.loaded || !this.filtersReady)return;
      const query=new URLSearchParams(location.search);
      this.favoriteMode=query.get('view_favorites')==='1';
      this.querySelector('[data-photo-find]').value=query.get('find')||'';
      this.querySelector('[data-photo-orientation]').value=['landscape','portrait','square'].includes(query.get('orientation'))?query.get('orientation'):'all';
      const color=this.querySelector('[data-photo-color]');if(color)color.value=['color','monochrome'].includes(query.get('color'))?query.get('color'):'all';
      this.querySelector('[data-photo-device-note]').hidden=!this.favoriteMode;
      this.querySelector('.photo-buyer__find').open=this.hasActiveFilters();
      await this.apply(false);
      this.gallery.restoreReturnFocus?.();
    }
    filterState(){return JSON.stringify([this.querySelector('[data-photo-find]')?.value.trim()||'',this.querySelector('[data-photo-orientation]')?.value||'all',this.querySelector('[data-photo-color]')?.value||'all',!!this.favoriteMode,this.gallery?.dataset.scope||'all']);}
    filtersPending(){return this.filterState()!==this.appliedFilterState;}
    async synchronize(){
      if(!this.isConnected)return false;
      if(this.abort?.signal.aborted){this.initialized=false;this.connectedCallback();}
      const grid=this.gallery.querySelector('.photo-gallery__grid');
      if(this.grid!==grid){this.grid=grid;this.originalNodes=[...grid.children];this.records=this.gallery.dataset.preview?[...grid.querySelectorAll('.photo-gallery__open')]:this.gallery.visibleItems(grid);}
      if(!this.loaded)await this.ready();
      await this.apply(true);
      return !this.filtersPending();
    }
    hasActiveFilters(){return this.favoriteMode||!!this.querySelector('[data-photo-find]').value.trim()||this.querySelector('[data-photo-orientation]').value!=='all'||(this.querySelector('[data-photo-color]')?.value||'all')!=='all';}
    currentItems(){return this.gallery.visibleItems(this.grid);}
    async apply(updateUrl){
      if(!this.loaded||!this.grid||this.gallery.dialog?.open)return;
      clearTimeout(this.timer);this.requestedFilterState=this.filterState();
      const version=this.filterVersion=(this.filterVersion||0)+1;
      const active=this.hasActiveFilters();
      if(active&&!this.gallery.dataset.preview&&this.gallery.nativePagination()){
        this.querySelector('[data-photo-count]').textContent=labels.filter_loading;
        try{this.records=await this.gallery.loadNativeSequence();}
        catch(error){if(version===this.filterVersion&&error.name!=='AbortError')this.querySelector('[data-photo-count]').textContent=labels.filter_failed;return;}
        if(version!==this.filterVersion||!this.isConnected)return;
      }
      if(this.colors)annotateColors(this.records,this.colors);
      const normalize=value=>value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase();
      const query=normalize(this.querySelector('[data-photo-find]').value.trim());const orientation=this.querySelector('[data-photo-orientation]').value;const color=this.querySelector('[data-photo-color]')?.value||'all';
      const scoped=this.records.filter(button=>this.gallery.dataset.scope==='all'||!this.gallery.dataset.preview||button.closest('figure').dataset.collections.split(',').includes(this.gallery.dataset.scope));
      const matched=scoped.filter(button=>(!this.favoriteMode||saved.has(button.dataset.photo))&&(!query||normalize(button.dataset.title+' '+text(button)).includes(query))&&(orientation==='all'||button.closest('figure').dataset.orientation===orientation)&&(color==='all'||button.dataset.color===color));
      this.matchedRecords=matched;
      if(this.gallery.dataset.preview){for(const button of this.records)button.closest('figure').hidden=!matched.includes(button);}
      else if(active){
        this.grid.replaceChildren(...matched.map(button=>{const card=document.createElement('figure');card.className='photo-gallery__card';card.dataset.orientation=button.closest('figure').dataset.orientation;const open=document.createElement('button');open.type='button';open.className='photo-gallery__open';Object.assign(open.dataset,button.dataset);open.setAttribute('aria-label',this.gallery.dataset.openLabel+': '+button.dataset.title);const image=document.createElement('img');const existing=button.querySelector('img');image.src=existing?.getAttribute('src')||button.dataset.image;image.alt=button.dataset.alt||button.dataset.title;image.loading='lazy';image.decoding='async';if(existing?.getAttribute('srcset'))image.srcset=existing.getAttribute('srcset');if(existing?.getAttribute('sizes'))image.sizes=existing.getAttribute('sizes');const caption=document.createElement('figcaption');const title=document.createElement('button');title.type='button';title.className='photo-gallery__title';title.dataset.galleryTitle='';title.textContent=button.dataset.title;open.append(image);caption.append(title);card.append(open,caption);return card;}));
      }else this.grid.replaceChildren(...this.originalNodes);
      this.gallery.arrange();for(const card of this.grid.querySelectorAll('.photo-gallery__card'))decorate(card);
      if(this.gallery.dataset.preview && window.PhotoCatalog.enabled){
        // The print route hides the grid while filters finish loading; use filter membership, not ancestor visibility.
        const membership=new Set(matched);
        this.matchedRecords=[...this.grid.querySelectorAll('.photo-gallery__open')].filter(button=>membership.has(button));
      }
      const shown=!this.gallery.dataset.preview&&!active?this.gallery.visibleItems(this.grid).length:matched.length;const total=!this.gallery.dataset.preview?Math.max(this.totalCount,scoped.length):scoped.length;this.querySelector('[data-photo-count]').textContent=labels.count.replace('[shown]',shown).replace('[total]',total);
      const empty=this.querySelector('[data-photo-empty]');empty.hidden=!!matched.length;empty.textContent=this.favoriteMode&&!query&&orientation==='all'&&color==='all'?labels.empty_saved:labels.no_matches;
      const browse=this.querySelector('[data-photo-empty-browse]');
      if(browse){browse.hidden=!this.favoriteMode||!!matched.length;const target=route('',this.gallery);browse.href=target.pathname+target.search+'#photographs';}
      if(updateUrl){const url=new URL(location.href);if(query)url.searchParams.set('find',this.querySelector('[data-photo-find]').value.trim());else url.searchParams.delete('find');if(orientation!=='all')url.searchParams.set('orientation',orientation);else url.searchParams.delete('orientation');if(color!=='all')url.searchParams.set('color',color);else url.searchParams.delete('color');history.replaceState(history.state,'',url.pathname+url.search+url.hash);}
      if(this.gallery.dataset.preview && window.PhotoCatalog.enabled)for(const button of this.records)button.href=this.gallery.printUrl(button.dataset.photo);
      this.appliedFilterState=this.filterState();
      updateSaved();
    }
  }
  window.PhotoBuyer={detailUrl,inquiryUrl,diagram,refreshActions:updateDetail,saved:()=>new Set(saved)};
  customElements.define('photo-buyer-tools',BuyerTools);
  document.addEventListener('photo-gallery:photo',event=>updateDetail(event.target));
  document.addEventListener('photo-print:created',event=>{const {page,size,photo}=event.detail;const container=page.querySelector('[data-print-diagram]');if(container)diagram(container,size,photo);});
  document.addEventListener('photo-print:dimensions',event=>{const container=event.target.querySelector('[data-print-diagram]');if(container)diagram(container,event.detail.size,event.detail.photo);});
  document.addEventListener('click',event=>{
    const save=event.target.closest('[data-favorite-handle]');if(save){toggle(save.dataset.favoriteHandle);const gallery=save.closest('photo-gallery');if(gallery)status(gallery,persistent?labels.device_note:labels.saved_visit);}
    const button=event.target.closest('[data-photo-share]');if(button)share(button.closest('photo-gallery'));
    const ask=event.target.closest('[data-photo-ask],[data-photo-guide]');if(ask&&expired(ask.closest('photo-gallery'))){event.preventDefault();status(ask.closest('photo-gallery'),ask.closest('photo-gallery').dataset.expiredLabel);}
  });
  window.addEventListener('storage',event=>{if(event.key===key){try{saved=clean(JSON.parse(event.newValue||'[]'));updateSaved(true);}catch{}}});
  window.addEventListener('pageshow',event=>{
    if(!event.persisted || !persistent)return;
    try{saved=clean(JSON.parse(localStorage.getItem(key)||'[]'));updateSaved(true);}catch{}
  });
  const query=new URLSearchParams(location.search);const title=(query.get('photo')||'').replace(/[\r\n]/g,' ').slice(0,256);const body=document.querySelector('textarea[name="contact[body]"]');
  if(title&&body&&!body.value.trim()){
    let link='';try{const value=query.get('photo_url');if(value){const url=new URL(value,config.origin);if(url.origin===new URL(config.origin).origin)link=url.href;}}catch{}
    body.value=labels.prefill.replace('[title]',title)+(link?'\n'+link:'')+'\n\n'+labels.question+'\n';body.dispatchEvent(new Event('input',{bubbles:true}));
  }
})();

